import {useHistory} from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import SearchIcon from '@material-ui/icons/Search';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Card, CardContent, FormControl, FormControlLabel,
    Grid, IconButton, InputLabel, Radio, RadioGroup, Select as MaterialSelect,
    TextField, Tooltip, Typography, LinearProgress, 
    Button} from '@material-ui/core'
//import TablaOrden from './TablaOrden';
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';

import {ErrorGeneral, llamadaApiToken, llamaApiCargaToken} from '../funciones/ClienteAxios';
import React, {useContext, useEffect, useState, useRef} from "react";
//import TablaBitacora from "./TablaBitacora.jsx";
import NumberFormat from 'react-number-format';

const useStyles = makeStyles((theme) => ({
    title2: {
        fontSize: 18,
    },
    subTitle2: {
        fontSize: 12,
    },
    altura2: {
        minHeight: 70,
        marginTop: 0,
        paddingTop: 0,
    },
    altura3: {
        minHeight: 145,
        marginTop: 0,
        paddingTop: 0,
    },
    card:{
        height:'5.1rem',
        width:120,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card3:{
        height:'5.1rem',
        width:170,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    card4:{
        height:'6rem',
        width:170,
        // padding:'1.1 rem 0px 1.12rem',
        marginRight:'.5em',
    },
    titulo:{
        //color:'#4a4a4a',
        textAlign:'center',
        marginTop:'-.4rem',
        fontSize:'1rem',
        fontWeight:600
    },
    tituloColor:{

        //color:'white',
        textAlign:'center',
        marginTop:'-.2rem',
        fontSize:'1.2rem',
        fontWeight:600
    },
    subtituloCard:{
       // color:'#4a4a4a',
       fontWeight:600,
        textAlign:'center',
        marginTop:'.4rem',
        fontSize:'.97rem',
    },
}));


const DashboardDinamico = () => {
    let history = useHistory();
    const source = axios.CancelToken.source();
    const auxColor=process.env.REACT_APP_COLOR
    const Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
    const idusu = localStorage.getItem('UsuId');
    const [opcion, setOpcion] =  useState(0);
    const {usuario, guardarUsuario} = useContext(AuthContext);
    const {guardarGenerales} = useContext(GeneralesContext);
    const[filtro,setFiltro] = useState({supervisa:false})
    const [listTipo,setListTipo] = useState([])
    const{supervisa}=filtro

    useEffect(() => {                       

        const veriSesion = () => {
            const usu = localStorage.getItem('UsuarioNom');
            const nvl = localStorage.getItem('Tipo');
            if (usu === null) {
                guardarUsuario([])
                guardarGenerales([])
                localStorage.clear();
                history.push("/")
            } else {
                if (usuario.length === 0) {
                    guardarUsuario({Nombre: usu, nivel: nvl});
                }
                getListTipo()
                guardarGenerales({Titulo: 'Tablero'})
                
            }
        }
        veriSesion();
        return () => {
            source.cancel();
        }
    }, []);
 
   const getListTipo = () => {    
     const data = qs.stringify({
         Usuario:idusu,
         ip:"127.0.0.0",               
         idDispositivo: auxDispV
     });
     const url = "/maquinaria/tipo";
 
     function respuesta(auxiliar) 
     { 
         if (auxiliar[0].Id !== -1) 
         { setOpcion(auxiliar[0].Id)                
           setListTipo(auxiliar)
         }
     }
     llamadaApiToken(data, url, respuesta, ErrorGeneral,  history, source);
   };

    const principal = (auxTipo) => {
        const token30 = localStorage.getItem('token30');
        const token20 = localStorage.getItem('token20');
        const auxtkn = token20.substring(token20.length-24,token20.length-1)
        //console.log(auxtkn);
        console.log(`https://alfa-board-qa.daduva.mx/prueba/1/${auxTipo}/${token30}/${auxtkn}`);
        
        return (    
        <Box  display={"flex"}  alignItems={'flex-start'} style={{width:"98vw",height:"80vh"}}>
            
            <iframe src={`https://alfa-board-qa.daduva.mx/prueba/1/${auxTipo}/${token30}/${auxtkn}`} style={{width:"100%", height:"100%"}}/>
            
        </Box>              
        )
    }

    
    return (
    <>
    <Box display={"flex"} flexDirection={"row"} mb={1} mt={1}>
        {listTipo.length!==0 ? listTipo.map((tipo)=>{
           if (tipo.Id !== 0) {
            
           return <Button variant={opcion===tipo.Id ?"contained":"outlined"} onClick={()=>setOpcion(tipo.Id)} color="primary" size="small" style={{marginLeft:"1rem"}}> {tipo.Descr}</Button>  /*<Card style={{padding:0, margin:0, backgroundColor: opcion===tipo.Id ? auxColor:"",
                   color: opcion===tipo.Id ? "white": auxColor, width:"12rem", marginLeft:"1rem",
                    textAlign:"center"
                  }} onClick={()=>setOpcion(tipo.Id)}>
                   <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem"}} > {tipo.Descr}</CardContent>
                 </Card>  
              /*    return <Card style={{padding:0, margin:0, backgroundColor: opcion===tipo.Id ? auxColor:"",
                   color: opcion===tipo.Id ? "white": auxColor, width:"12rem", marginLeft:"1rem",
                    textAlign:"center"
                  }} onClick={()=>setOpcion(tipo.Id)}>
                   <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem"}} > <Button  onClick={()=>setOpcion(tipo.Id)} color="primary" size="small" style={{marginLeft:"1rem"}}> {tipo.Descr}</Button>  </CardContent>
                 </Card> */
           }
        }):null}
    </Box>
        {listTipo.length!==0 && opcion!==0?principal(opcion):null}
        
    </>
    )
}

export default DashboardDinamico